/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index input-masked to autogenerate all the components and extensions
 * Used by "prepareInputMaskeds"
 */

import InputMasked from './input-masked/InputMasked'
export * from './input-masked/InputMasked'
export default InputMasked
